import styles from './sidebar.module.scss';
import { NavLink } from 'react-router-dom';
import { Accordion, AccordionDetails, AccordionSummary, List } from '@material-ui/core';
import classNames from 'classnames';
import { Path } from 'enums';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { useContext } from 'react';
import { UserContext } from 'contexts';

const Navigation = [
  {
    label: 'Members',
    link: Path.MemberList,
    exact: true
    // needHideAdmin: true
  },
  {
    label: 'Reports',
    link: Path.Transaction,
    // needHideAdmin: true,
    items: [
      {
        label: 'Savings',
        link: `${Path.Transaction}/report/savings`,
        child: false
      },
      {
        label: 'Shared Capital',
        link: `${Path.Transaction}/report/shared-capital`,
        child: false
      }
      // {
      //   label: 'Fixed Deposit',
      //   link: `${Path.Transaction}/fixed-deposit`,
      //   child: false
      // },
      // {
      //   label: 'Claims',
      //   link: `${Path.Transaction}/claims`,
      //   child: false
      // }
    ]
  },
  {
    label: 'Products',
    link: Path.Products,
    exact: true
    // needAdmin: true
  },
  {
    label: 'Users',
    link: Path.Users,
    exact: true
    // needAdmin: true
  }
];

const ChildItem = (props) => {
  const { item } = props;
  const parent = (
    <NavLink
      to={item.link}
      className={classNames(styles.listItem, {
        [`${styles.enabledLink}`]: !item?.items?.length,
        [`${styles.disabledLink}`]: item?.items?.length
      })}
      activeClassName={classNames(item, styles.selectedMenu)}
    >
      <span className={styles.item}>
        <span className={styles.listText}>{item.label}</span>
      </span>
    </NavLink>
  );
  return (
    <Accordion elevation={0}>
      {item?.items?.length ? (
        <AccordionSummary expandIcon={<ExpandMoreIcon className={styles.expandIcon} />}>{parent}</AccordionSummary>
      ) : (
        <></>
      )}
      <AccordionDetails>
        <div className={styles.child}>
          {item.items.map((child, childKey) => {
            return (
              <NavLink key={childKey} to={child.link} className={classNames(styles.listItem)} activeClassName={styles.active}>
                <span className={styles.listIconRoot}>{child.icon && <span className={`icon ${child.icon}`} />}</span>
                <span className={styles.listText}>{child.label}</span>
              </NavLink>
            );
          })}
        </div>
      </AccordionDetails>
    </Accordion>
  );
};

const Sidebar = () => {
  const user = useContext(UserContext);
  const isAdmin = ['admin', 'super-admin'].includes(user?.role);

  return (
    <div className={styles.sidebarContainer}>
      <List className={styles.sidebarList}>
        {Navigation.map((item, index) => {
          if (!item || (item.needAdmin && !isAdmin) || (item.needHideAdmin && user?.role === 'admin')) return <></>;

          return (
            <span key={index}>
              {item.exact ? (
                <NavLink to={item.link} exact={true} className={classNames(styles.listItem)} activeClassName={styles.active}>
                  <span className={styles.item}>
                    <span className={styles.listText}>{item.label}</span>
                  </span>
                </NavLink>
              ) : (
                <ChildItem item={item} />
              )}
            </span>
          );
        })}
      </List>
    </div>
  );
};

export default Sidebar;
